import { Button } from 'components/universal/button';
import { useTranslation } from 'react-i18next';
import cls from './howToGetCertificate.module.scss';

interface GenerateLoginFormInterface {
    onCancel: (boolean) => void;
}

export const HowToGetCertificate = ({
    onCancel
}: GenerateLoginFormInterface) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className={cls.modalHeader}>{t('employeeManagement.howToGetCertificateTitle')}</h3>
            <p className={cls.modalDescription}>{t('employeeManagement.howToGetCertificateDescription')}</p>
            <p className={cls.modalNames}>{t('employeeManagement.howToGetCertificateAdminInfo')}</p>
            <div className={cls.modalButtonWrapper}>
                <Button className={cls.modalButton} styleType="border" type="button" onClick={onCancel}>
                    {t('employeeManagement.howToGetCertificateConfirmButton')}
                </Button>
            </div>
        </>
    );
};
